import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Grid, InputBase, IconButton, Link} from '@material-ui/core';
import ProductCard from 'Components/order/ProductCard';
import Header from 'Components/lto/common/Header';
import {T} from 'Actions/translate';
import {
    getShipToInfo,
    getCategoryList,
    updateCategroySelected,
    getProductList,
    getMoreProducts,
    addCart,
    getCartCount,
    getDefaultShipToAndSC,
    queryTMSKUList,
    updateOtherShipToNumber,
    updateProductSearchFields,
    getQuote,
    getCustomerQuote,
    operationLog,
    updateProducts,
    queryEoneInventory,
} from 'Actions/order';
import {Search, PlaceOutlined, TouchAppSharp} from '@material-ui/icons';
import Dialog from 'Components/common/Dialog';
import BasicButton from 'Components/common/BasicButton';
import Anchor from 'Components/common/Anchor';
import {mockLogin} from 'Actions/auth';
import ScrollWrapper from '../common/ScrollWrapper';
import Icon from '@material-ui/core/Icon';
import LoadingIcon from 'Components/icons/LoadingIcon';
import {removeProfile, removeIdToken} from 'Utils/jwtUtil';
import {setUserData} from 'Actions/localData';
import util from 'Utils/commonUtil';
import {unBindGigya} from 'Actions/bind';
import {openNotification} from 'Actions/notification';
import {PURCHASE_ORDER_MODE, PURCHASE_ORDER} from 'Utils/constant';

import copy from 'copy-to-clipboard';

class ProductList extends Component {
    state = {
        searchKey: '',
        supplyCenterOpen: false,
        categroyOpen: false,
        shipToOpen: false,
        supplyCenterSort: 'asc',
        categroySort: 'asc',
        categroySelected: {
            key: 0,
            value: T('allProduct'),
        },
        shipToSelected: '',
        chosed: false,
        displayTMProduct: false,
        pageLoad: true,
        // isGuset: true,
        isDemoSite: true,
        locationHidden: false,
        warningOpen: false,
        unBindDialogOpen: false,
        exitOpened: false,
        currentShippingAddress: '',
        selectedShipToClassName: '',
        isQuoteInfor: false,
        cmgtInventoryList: [],
        addPageType: null,
        isProxyProcessType: null,
        onlineOrderDialogOpened: false,
        timer: PURCHASE_ORDER.TIMER,
    };

    searchRequestTimer = null;

    /**
		With Gigya Init Page
	*/

    componentWillMount() {
        var url = this.props.location.search;
        let urlParam;
        let urlParamValue;
        let currentShipToNumber = util.getShipToNumber(this.props.localData);
        let currentSCdata;

        if (this.props.match.url.indexOf('test') !== -1) {
            currentSCdata = {
                scId: null,
                scName: null,
                scType: null,
            };
            this.props.updateCategroySelected({
                key: 0,
                value: T('allProduct'),
            });
            this.props.updateProductSearchFields('');
        } else {
            currentSCdata = util.getSCdata(this.props.localData);
        }

        this.setState({
            categroySelected: this.props.categroySelected,
        });

        if (this.props.otherShipToNumber) {
            currentShipToNumber = this.props.otherShipToNumber;
        }

        let codeArry = [];
        if (url.indexOf('?') !== -1) {
            let str = url.substr(1);
            let strs = str.split('&');
            for (var i = 0; i < strs.length; i++) {
                urlParam = strs[i].split('=')[0];
                urlParamValue = strs[i].split('=')[1];

                if (strs[i].split('=')[0] === 'code' && strs[i].split('=')[1]) {
                    codeArry = strs[i].split('=');
                }
            }

            if (urlParam === 'isProxyUser' && urlParamValue) {
                this.proxyProcess();
            }
        } else if (this.props.match.params && this.props.match.params.id) {
            removeProfile();
            this.props.mockLogin(
                {
                    id: this.props.match.params.id,
                    scData: currentSCdata,
                },
                this.initPage,
            );
        } else {
            this.proxyProcess();
        }

        if (
            util.getPurchaseOrderMode() === PURCHASE_ORDER_MODE.ONLINE ||
            util.getPurchaseOrderMode() === PURCHASE_ORDER_MODE.OFFLINE
        ) {
            if (
                !this.props.searchValue &&
                this.getFromSelectCustomerPage() &&
                !this.props.fromProductSearchPage &&
                !this.props.fromShoppingCart
            ) {
                this.setState(
                    {
                        onlineOrderDialogOpened: true,
                    },
                    () => {
                        this.timeHandle();
                    },
                );
            }
        }
    }

    timeHandle = () => {
        window.clearInterval(this.intervalTimer);
        this.intervalTimer = setInterval(() => {
            if (this.state.timer === 0) {
                this.setState({
                    onlineOrderDialogOpened: false,
                });
            } else {
                this.setState({timer: this.state.timer - 1});
            }
        }, 1000);
    };

    openOnlineOrderDialog = () => {
        this.setState({
            timer: PURCHASE_ORDER.TIMER,
            onlineOrderDialogOpened: true,
        });
    };

    getFromSelectCustomer = () => {
        let fromSelectCustomer = false;
        let routerState = util.getRouterState(
            this.props.history.location.state,
        );
        if (JSON.stringify(routerState) !== '{}') {
            fromSelectCustomer = routerState.fromSelectCustomer;
        }
        return fromSelectCustomer;
    };

    getPurchaseCustomerName = () => {
        let customerName = '';
        let routerState = util.getRouterState(
            this.props.history.location.state,
        );
        if (JSON.stringify(routerState) !== '{}') {
            customerName = routerState.customerName;
        }
        return customerName;
    };

    getPurchaseCustomerEmail = () => {
        let customerEmail = undefined;
        let routerState = util.getRouterState(
            this.props.history.location.state,
        );
        if (JSON.stringify(routerState) !== '{}') {
            customerEmail = routerState.customerEmail;
        }
        return customerEmail;
    };

    getFromSelectCustomerPage = () => {
        let fromSelectCustomerPage = undefined;
        let routerState = util.getRouterState(
            this.props.history.location.state,
        );
        if (JSON.stringify(routerState) !== '{}') {
            fromSelectCustomerPage = routerState.fromSelectCustomerPage;
        }
        return fromSelectCustomerPage;
    };

    // Proxy Process
    proxyProcess = () => {
        const {localData} = this.props;
        let isDemoSite = false;
        this.props.getCartCount(localData.customerEmail);
        this.props
            .getDefaultShipToAndSC({
                shipToNum: localData.shipToNum,
            })
            .then((res) => {
                this.getProduct({}, false, false);
            });

        this.setState({
            isDemoSite: isDemoSite,
        });

        if (
            document.getElementById('product-classify') &&
            document.getElementById('mask')
        ) {
            document.getElementById('mask').style.marginTop =
                document.getElementById('product-classify').clientHeight + 'px';
        }

        setTimeout(() => {
            this.setState({
                locationHidden: true,
            });
        }, 3000);
    };

    // Handle Serach Action
    handleSearch = (event) => {
        // const { isDemoSite } = this.state;
        this.setState({searchKey: event.target.value});
        /* let searchParam = {
			'categoryId': this.state.categroySelected.key !== 0 ? this.state.categroySelected.key : '',
			'skuQuery': event.target.value ? event.target.value.trim() : event.target.value
		}

		this.getProduct(searchParam, true, isDemoSite); */
    };

    // Clear Other ShipTO Chosen
    clearChosed = () => {
        let shipToLi = document
            .getElementById('shipToAddress')
            .getElementsByTagName('li');
        for (var i = 0; i < shipToLi.length; i++) {
            shipToLi[i].className = '';
        }
    };

    // Get More Product For Lazy Loading
    getMoreProducts = () => {
        const {productList, localData} = this.props;
        let currentShipToNumber = util.getShipToNumber(localData);
        this.props
            .getMoreProducts(
                {
                    email: localData.customerEmail,
                    supplyCenterId: localData.scId
                        ? localData.scId
                        : localData.defaultScId,
                    pageSize: 10,
                    categoryId:
                        this.state.categroySelected.key !== 0
                            ? this.state.categroySelected.key
                            : '',
                    skuQuery: this.props.searchValue
                        ? this.props.searchValue.trim()
                        : this.props.searchValue,
                    pageNum:
                        productList && productList.pageNum
                            ? productList.pageNum + 1
                            : 1,
                    shipToNumber: currentShipToNumber,
                    purchaseOrderMode: util.getPurchaseOrderMode(),
                },
                this.state.isDemoSite,
            )
            .then((resp) => {
                this.setState({
                    isProxyProcessType: this.props.searchValue.trim()
                        ? 'Search Results'
                        : 'Home Page',
                });
            });
    };

    // Close Menu Compnent
    handleClose = (value) => {
        if (value === 'supplyCenter') {
            this.setState({
                supplyCenterOpen: false,
                supplyCenterSort: 'asc',
            });
        } else if (value === 'categroy') {
            this.setState({
                categroyOpen: false,
                categroySort: 'asc',
            });
        } else if (value === 'shipTo') {
            this.setState({
                shipToOpen: false,
            });
        } else if (value === 'all') {
            this.setState({
                supplyCenterOpen: false,
                categroyOpen: false,
                shipToOpen: false,
                supplyCenterSort: 'asc',
                categroySort: 'asc',
            });
        }
        this.disableOverFlow(false);
    };

    // Key Down Event Handling
    keyDown = (event) => {
        if (event.keyCode === 13) {
            const {isDemoSite} = this.state;

            this.handleSearch(event);
            event.currentTarget.blur();
            let searchParam = {
                categoryId:
                    this.state.categroySelected.key !== 0
                        ? this.state.categroySelected.key
                        : '',
                skuQuery: event.target.value
                    ? event.target.value.trim()
                    : event.target.value,
            };

            this.getProduct(searchParam, true, isDemoSite, 'Search Results');
        }
    };

    // Go To Product Search Page
    goToProductSearchPage = () => {
        this.props.history.push('/purchase/productSearchPage', {
            customerEmail: util.getPurchaseCustomerEmail(),
            customerName: util.getPurchaseCustomerName(),
        });
    };

    // Add Shopping Cart Button event Handling
    addShoppingCart = (productInfo, num, event) => {
        const {localData} = this.props;
        const animationTime = 600;

        let isPhoneFlag = false;
        if (
            util.isPhone() &&
            event.touches !== 'undefined' &&
            event.touches &&
            event.touches.length > 0
        ) {
            isPhoneFlag = true;
        }
        const clientX = isPhoneFlag ? event.touches[0].clientX : event.clientX;
        const clientY = isPhoneFlag ? event.touches[0].clientY : event.clientY;

        if (this.state.isDemoSite) {
            this.openLiteWarning();
        } else {
            this.props.operationLog({
                opTarget: 'add_sku_to_cart',
                opContent: productInfo.sku,
                opReqUrl: '/api/cart/add',
            });
            this.props
                .addCart({
                    productId: productInfo.id,
                    customerEmail: localData.customerEmail,
                    quantity: num,
                    sku: productInfo.sku,
                })
                .then(() => {
                    const shoppingCartBtn =
                        document.getElementById('shippingcart-btn');
                    if (productInfo && num) {
                        let pageType;
                        if (
                            this.props.history.location.state &&
                            this.state.addPageType == null &&
                            (this.props.history.location.state.type ==
                                'Search Results' ||
                                this.props.history.location.state.type ==
                                    'Recent Searches' ||
                                this.props.history.location.state.type ==
                                    'Hot Searches')
                        ) {
                            pageType = this.props.history.location.state.type;
                        } else if (
                            this.state.addPageType !== null &&
                            this.state.addPageType == 'Thermofisher Searches'
                        ) {
                            pageType = 'Thermofisher Searches';
                        } else {
                            pageType = 'Home Page';
                        }

                        if (this.state.isProxyProcessType) {
                            pageType = this.state.isProxyProcessType;
                        }
                    }
                    let params = {
                        shoppingCartBtn: shoppingCartBtn,
                        productInfo: productInfo,
                        event: event,
                        animationTime: animationTime,
                        clientX: clientX,
                        clientY: clientY,
                    };
                    util.addShoppingCartAnimation(params);
                });
        }
    };

    // Call Get Product Api
    getProduct = (params, noShipToChangeFlg, isDemoSite, type) => {
        let pageType;
        if (
            this.props.history.location.state &&
            this.props.history.location.state.type
        ) {
            pageType = this.props.history.location.state.type;
        } else {
            pageType = this.props.searchValue.trim()
                ? 'Search Results'
                : 'Home Page';
        }
        const {localData} = this.props;

        this.setState({
            pageLoad: true,
            isProxyProcessType: pageType,
            addPageType: null,
        });

        this.props.updateProducts({$set: []});

        if (params.data) {
            params.supplyCenterId =
                params.data &&
                params.data.supplyCenter &&
                params.data.supplyCenter.id
                    ? params.data.supplyCenter.id
                    : localData.scId
                    ? localData.scId
                    : localData.defaultScId;
        }

        window.clearTimeout(this.searchRequestTimer);
        this.searchRequestTimer = setTimeout(() => {
            console.log('trigger');
            this.props
                .getProductList(
                    {
                        email: localData.customerEmail,
                        supplyCenterId:
                            params && params.supplyCenterId
                                ? params.supplyCenterId
                                : localData.scId
                                ? localData.scId
                                : localData.defaultScId,
                        pageNum: params && params.pageNum ? params.pageNum : 1,
                        pageSize:
                            params && params.pageSize ? params.pageSize : 10,
                        skuQuery:
                            params && params.skuQuery
                                ? params.skuQuery
                                : this.props.searchValue
                                ? this.props.searchValue.trim()
                                : this.props.searchValue,
                        categoryId:
                            params && params.categoryId
                                ? params.categoryId
                                : this.state.categroySelected.key || '',
                        shipToNumber:
                            params && params.data && params.data.shipTo
                                ? params.data.shipTo.stNumber
                                : util.getShipToNumber(localData),
                        purchaseOrderMode: util.getPurchaseOrderMode(),
                    },
                    this.hideloading,
                    isDemoSite,
                )
                .then(() => {
                    if (
                        this.props.productList.data &&
                        this.props.productList.data.length > 0
                    ) {
                        if (this.props.searchValue.trim()) {
                            document
                                .getElementsByClassName('search-input')[0]
                                .getElementsByTagName('input')[0]
                                .setAttribute(
                                    'class',
                                    'search_result_has_content',
                                );
                            document
                                .getElementsByClassName('search-input')[0]
                                .getElementsByTagName('input')[0]
                                .setAttribute(
                                    'testid',
                                    'search-result-sku-content',
                                );
                        }
                        const skuArr = this.props.productList.data.map(
                            (item) => item.sku,
                        );
                        this.getQuote(skuArr);
                    } else {
                        if (this.props.searchValue.trim()) {
                            document
                                .getElementsByClassName('search-input')[0]
                                .getElementsByTagName('input')[0]
                                .setAttribute(
                                    'class',
                                    'search_result_no_content',
                                );
                        }
                    }
                });
        }, 500);
    };

    // Hide API Get Loading
    hideloading = () => {
        //update SCME-1357
        if (this.props.localData.defaultScId !== 0 && this.state.isDemoSite) {
            this.setState({
                isDemoSite: false,
            });
        }
        this.setState({
            pageLoad: false,
        });
    };

    // TM Handle Serach
    handleSearchTM = (event) => {
        this.props.updateProductSearchFields(event.target.value);
    };

    // TM Key Down Event Handling
    keyDownTM = (event) => {
        if (event.keyCode === 13) {
            this.handleSearchTM(event);
            event.currentTarget.blur();
            this.displayTMProduct(event.target.value);
        }
    };

    // Display Thermofisher Product
    displayTMProduct = (value) => {
        const {localData} = this.props;

        this.setState(
            {
                displayTMProduct: true,
                pageLoad: true,
            },
            () => {
                if (
                    util.getPurchaseOrderMode() ===
                        PURCHASE_ORDER_MODE.ONLINE &&
                    document.getElementById('header-background')
                ) {
                    document.getElementById('header-background').style.height =
                        9.5 + 'rem';
                }
            },
        );

        let currentShipToNumber = util.getShipToNumber(localData);
        let searchParm = value
            ? value.trim()
            : this.props.searchValue
            ? this.props.searchValue.trim()
            : this.props.searchValue;
        if (searchParm && searchParm.length >= 3) {
            let searchParmKey = encodeURIComponent(searchParm);
            this.props
                .queryTMSKUList(
                    searchParmKey,
                    currentShipToNumber,
                    this.hideloading,
                )
                .then((res) => {
                    if (
                        this.props.tmProductList.status === 'success' &&
                        this.props.tmProductList.data &&
                        this.props.tmProductList.data.length > 0
                    ) {
                        if (this.props.searchValue.trim()) {
                            document
                                .getElementsByClassName('search-input')[0]
                                .getElementsByTagName('input')[0]
                                .setAttribute(
                                    'class',
                                    'search_result_has_content',
                                );
                            document
                                .getElementsByClassName('search-input')[0]
                                .getElementsByTagName('input')[0]
                                .setAttribute(
                                    'testid',
                                    'search-result-sku-content',
                                );
                        }
                        let skuArr = [];
                        this.props.tmProductList.data.map((item) => {
                            if (item.type === 2) {
                                skuArr.push(item.sku);
                            }

                            return null;
                        });
                        this.queryCMGTInventory(
                            skuArr,
                            this.props.tmProductList.data,
                        );
                        // this.getQuote(skuArr);
                        this.setState({
                            addPageType: 'Thermofisher Searches',
                            isProxyProcessType: null,
                        });
                    } else {
                        if (this.props.searchValue.trim()) {
                            document
                                .getElementsByClassName('search-input')[0]
                                .getElementsByTagName('input')[0]
                                .setAttribute(
                                    'class',
                                    'search_result_no_content',
                                );
                        }
                    }
                })
                .catch((err) => {
                    this.hideloading();
                });
        } else {
            this.hideloading();
            this.props.openNotification(
                T('order_tm_query_Key_error'),
                'success',
                {
                    testid: 'product-search-keyword-validation',
                },
            );
        }
    };

    // Back Button Event Action
    backEvent = () => {
        const {localData} = this.props;

        this.setState({
            displayTMProduct: false,
            searchKey: '',
            // categroySelected: {
            // 	key: 0,
            // 	value: T('allProduct')
            // }
        });

        this.getProduct(
            {
                supplyCenterId: localData.scId
                    ? localData.scId
                    : localData.defaultScId,
                categoryId:
                    this.state.categroySelected.key !== 0
                        ? this.state.categroySelected.key
                        : '',
                skuQuery: this.props.searchValue
                    ? this.props.searchValue.trim()
                    : this.props.searchValue,
            },
            true,
        );
    };

    goBack = () => {
        this.props.history.goBack();
    };

    // Navigate To Shopping Cart Page
    goToShoppingCart = () => {
        // if (!this.state.isGuset) {
        if (this.state.isDemoSite) {
            this.openLiteWarning();
        } else {
            if (this.props.match.url.indexOf('test') !== -1) {
                this.props.history.push('/testShoppingCart');
            } else {
                this.props.history.push('/purchase/shoppingCart', {
                    customerEmail: util.getPurchaseCustomerEmail(),
                    customerName: util.getPurchaseCustomerName(),
                });
            }
        }
        // }
    };

    // Navigate To User Center Page
    goToUserCenter = () => {
        const {localData} = this.props;
        if (!localData.customerEmail) {
            if (typeof localData.roleType === 'undefined') {
                if (localStorage.getItem('loginFrom') === 'web_browser') {
                    this.setState({
                        exitOpened: true,
                    });
                } else {
                    this.setState({
                        unBindDialogOpen: true,
                    });
                }
            }
        } else {
            this.props.history.push('/userCenter');
        }
    };

    // Open Warning For Lite Account
    openLiteWarning = () => {
        this.setState({
            warningOpen: true,
        });
    };

    // Close Warning For Lite Account
    closeWarning = () => {
        if (this.state.warningOpen) {
            this.setState({
                warningOpen: false,
            });
        }
    };

    // Close Warning For Lite Account
    closeUnbindDialog = () => {
        if (this.state.unBindDialogOpen) {
            this.setState({
                unBindDialogOpen: false,
            });
        }
    };

    closeDialog = (name) => {
        if (this.state[name]) {
            this.setState({
                [name]: false,
            });
        }
    };

    // Disable the scroll
    disableOverFlow = (flg, openShipTo) => {
        let body = document.getElementsByTagName('body')[0];

        if (flg) {
            if (typeof openShipTo === 'undefined') {
                body.style.overflow = 'hidden';
                window.scrollTo(0, 0);
            }
        } else {
            body.style.overflow = 'visible';
        }
    };

    exitCustomer = () => {
        removeIdToken();
        removeProfile();
    };

    getQuote = (param) => {
        this.props.getCustomerQuote(param, false);
    };

    quoteCallback = (res) => {
        if (res.status === 'success' && res.data.length !== 0) {
            this.setState({
                isQuoteInfor: true,
            });
        } else if (res.status === 'success' && res.data.length === 0) {
            this.props.openNotification(
                T('notification_quote_null'),
                'success',
            );
        } else {
            this.props.openNotification(
                T('notification_get_quote_failed'),
                'success',
            );
        }
    };

    closeQuoteDetails = () => {
        this.setState({
            isQuoteInfor: false,
        });
    };

    copyContent = (text) => {
        copy(text);
        this.props.openNotification(T('notification_copy_success'), 'success');
    };

    viewSkuDetail = (sku) => {
        if (!this.state.isDemoSite) {
            this.props.operationLog({
                opTarget: 'view_sku_detail',
                opContent: sku,
            });
        }
    };

    queryCMGTInventory = (params, tfsProductList) => {
        this.props.queryEoneInventory({skuList: params}).then((res) => {
            if (res) {
                let arr = tfsProductList.concat();
                arr.map((obj) => {
                    res.data.map((item) => {
                        if (item.sku === obj.sku) {
                            obj.availableInventory = parseInt(
                                item.availableInventory,
                            );
                        }

                        return null;
                    });

                    return null;
                });

                this.setState({
                    cmgtInventoryList: arr,
                });
            }
        });
    };

    getSearchProductType = () => {
        let currentProductType = '';
        if (
            this.props.history.location.state &&
            this.state.addPageType == null &&
            (this.props.history.location.state.type === 'Search Results' ||
                this.props.history.location.state.type === 'Recent Searches' ||
                this.props.history.location.state.type === 'Hot Searches')
        ) {
            currentProductType = this.props.history.location.state.type;
        } else if (
            this.state.addPageType !== null &&
            this.state.addPageType == 'Thermofisher Searches'
        ) {
            currentProductType = 'Thermofisher Searches';
        } else {
            currentProductType = 'Home Page';
        }
        return currentProductType;
    };

    getCurrentSupplyCenterEnabled = () => {
        const {localData, defaultShipToAndSc} = this.props;
        let currentSupplyCenterID = localData.scId
            ? localData.scId
            : localData.defaultScId;
        let currentScEnabled = 'Y';

        if (defaultShipToAndSc && JSON.stringify(defaultShipToAndSc) !== '{}') {
            if (
                defaultShipToAndSc.status === 'success' &&
                defaultShipToAndSc.data &&
                defaultShipToAndSc.data.supplyCenter
            ) {
                if (
                    defaultShipToAndSc.data.supplyCenter.id &&
                    defaultShipToAndSc.data.supplyCenter.id ===
                        currentSupplyCenterID
                ) {
                    currentScEnabled =
                        defaultShipToAndSc.data.supplyCenter.enabled;
                }
            }
        }

        return currentScEnabled;
    };

    getHeaderContent = () => {
        const {localData} = this.props;
        const {supplyCenterSort} = this.state;
        return (
            <div className="lto-product-list-header-content">
                {util.getPurchaseOrderMode() === PURCHASE_ORDER_MODE.ONLINE && (
                    <Grid className="customer-email-content" item xs={11}>
                        <img
                            src={
                                new URL(
                                    'Images/customer_icon.svg',
                                    import.meta.url,
                                ).href
                            }
                            alt=""
                        />
                        <label className="text-ellipsis">
                            {util.getPurchaseCustomerName()}
                        </label>
                        <label className="text-ellipsis">
                            {util.getPurchaseCustomerEmail()}
                        </label>
                    </Grid>
                )}
                <Grid className="shipto-and-sc" item xs={11}>
                    <Grid
                        className="left-content"
                        item
                        xs={3}
                        testid="product_list_header_ship_to_number">
                        <img
                            src={new URL('Images/ST.svg', import.meta.url).href}
                            alt=""
                        />
                        {localData.shipToNum}
                    </Grid>
                    <Grid className={'content-hidden '} item xs={8}>
                        <PlaceOutlined />
                        <div
                            className={
                                'left text-ellipsis ' + supplyCenterSort
                            }>
                            {localData.scName
                                ? localData.scName
                                : localData.defaultScName}
                        </div>
                    </Grid>
                </Grid>
            </div>
        );
    };

    render() {
        const {
            searchKey,
            supplyCenterOpen,
            categroyOpen,
            shipToOpen,
            supplyCenterSort,
            displayTMProduct,
            pageLoad,
            isDemoSite,
            warningOpen,
            exitOpened,
            isQuoteInfor,
            isProxyProcessType,
            addPageType,
            onlineOrderDialogOpened,
            timer,
        } = this.state;
        const {
            productList,
            shipTo,
            listLoaded,
            productLoadingMore,
            cartCount,
            localData,
            tmProductList,
            quoteCustomerInfor,
            searchValue,
        } = this.props;
        const chooseProductList = displayTMProduct
            ? tmProductList
            : productList;
        const productAbyss = displayTMProduct
            ? true
            : chooseProductList.pageNum >= chooseProductList.pageTotal;

        const currentProductType = this.getSearchProductType();
        return (
            <div className="product-list lto-product-list">
                <div className="container-max-width is-fixed background"></div>
                <div
                    id={
                        util.getPurchaseOrderMode() ===
                        PURCHASE_ORDER_MODE.OFFLINE
                            ? 'offlineHeaderBackgroundCover'
                            : ''
                    }
                    className={util.getClassName({
                        'container-max-width is-fixed': true,
                        'background-cover': true && !displayTMProduct,
                        'background-cover-tm': true && displayTMProduct,
                    })}></div>

                <Header
                    userIconEvent={this.goToUserCenter}
                    shoppingCartEvent={this.goToShoppingCart}
                    backEvent={this.goBack}
                    openOnlineOrderDialog={this.openOnlineOrderDialog}
                    increment={0}
                    hasShoppingCart={true}
                    hasUserCenter={true}
                    hasArrowBackIos={true}
                    ltoPageTitle={
                        util.getPurchaseOrderMode() ===
                        PURCHASE_ORDER_MODE.ONLINE
                            ? T('lto_purchase_order_line_up')
                            : T('lto_purchase_order_line_down')
                    }
                    cartCount={cartCount}
                    showTipIcon={true}
                    noHomeButton={true}>
                    {!displayTMProduct ? (
                        <Grid
                            className="product-classify-container no-margin"
                            container
                            spacing={0}
                            justify={'space-evenly'}
                            id="product-classify">
                            {util.getPurchaseOrderMode() ===
                                PURCHASE_ORDER_MODE.ONLINE && (
                                <Grid
                                    className="customer-email-content"
                                    item
                                    xs={11}>
                                    <img
                                        src={
                                            new URL(
                                                'Images/customer_icon.svg',
                                                import.meta.url,
                                            ).href
                                        }
                                        alt=""
                                    />
                                    <label className="text-ellipsis">
                                        {util.getPurchaseCustomerName()}
                                    </label>
                                    <label className="text-ellipsis">
                                        {util.getPurchaseCustomerEmail()}
                                    </label>
                                </Grid>
                            )}
                            <Grid className="shipto-and-sc" item xs={11}>
                                <Grid
                                    className="left-content"
                                    item
                                    xs={3}
                                    testid="product_list_header_ship_to_number">
                                    <img
                                        src={
                                            new URL(
                                                'Images/ST.svg',
                                                import.meta.url,
                                            ).href
                                        }
                                        alt=""
                                    />
                                    {localData.shipToNum}
                                </Grid>
                                <Grid className={'content-hidden '} item xs={8}>
                                    <PlaceOutlined />
                                    <div
                                        className={
                                            'left text-ellipsis ' +
                                            supplyCenterSort
                                        }>
                                        {localData.scName
                                            ? localData.scName
                                            : localData.defaultScName}
                                    </div>
                                </Grid>
                            </Grid>
                        </Grid>
                    ) : null}
                    {displayTMProduct ? (
                        <Grid
                            className="page-title-container no-margin"
                            container
                            spacing={0}
                            justify={'space-evenly'}>
                            <Grid item xs={12}>
                                {this.getHeaderContent()}
                            </Grid>
                            <Grid className="page-search" item xs={12}>
                                <div className="search-icon">
                                    <Search />
                                </div>
                                <form>
                                    <InputBase
                                        placeholder={T('enterProductName')}
                                        className="search-input"
                                        type={'search'}
                                        onKeyDown={this.keyDownTM}
                                        onChange={this.handleSearchTM}
                                        value={searchValue}
                                    />
                                </form>
                            </Grid>
                        </Grid>
                    ) : (
                        <Grid
                            className="page-search-container no-margin"
                            container
                            spacing={0}
                            justify={'space-evenly'}>
                            <Grid className="page-search" item xs={11}>
                                <div className="search-icon">
                                    <Search />
                                </div>
                                <form>
                                    <InputBase
                                        placeholder={T('enterProductName')}
                                        className="search-input"
                                        type={'search'}
                                        inputProps={{
                                            testid: 'productListSearchInput',
                                        }}
                                        onKeyDown={
                                            isDemoSite ? this.keyDown : null
                                        }
                                        onChange={
                                            isDemoSite
                                                ? this.handleSearch
                                                : null
                                        }
                                        value={
                                            isDemoSite ? searchKey : searchValue
                                        }
                                        onClick={
                                            isDemoSite
                                                ? null
                                                : this.goToProductSearchPage
                                        }
                                    />
                                </form>
                            </Grid>
                        </Grid>
                    )}
                </Header>

                <div
                    id="mask"
                    className={
                        supplyCenterOpen || shipToOpen || categroyOpen
                            ? 'mask'
                            : 'none'
                    }
                    onClick={this.handleClose.bind(this, 'all')}></div>

                <ScrollWrapper
                    showLoadingMore={productLoadingMore}
                    showAbyss={productAbyss}
                    getMoreData={this.getMoreProducts}
                    listLoaded={listLoaded}>
                    <div
                        id="menu"
                        className={
                            shipToOpen
                                ? 'ship-to-color menu-popup'
                                : 'menu-popup'
                        }>
                        {(localData.roleType === 1 ||
                            localData.roleType === 3) &&
                        this.getCurrentSupplyCenterEnabled() === 'N' &&
                        !displayTMProduct ? (
                            <div className="current-shippment-address">
                                <div className="show-deliver-address">
                                    {T('supply_center_suspended_business')}
                                </div>
                            </div>
                        ) : null}
                    </div>

                    {pageLoad ? (
                        <LoadingIcon className="circle-animation" />
                    ) : (
                        <Grid
                            className={util.getClassName({
                                'product-card-list-container':
                                    true && !displayTMProduct,
                                'tm-product-card-list-container':
                                    true && displayTMProduct,
                                'no-margin': true,
                            })}
                            container
                            spacing={0}
                            justify={'space-evenly'}>
                            {chooseProductList.data &&
                                chooseProductList.data.map((item, i) => {
                                    return (
                                        <Grid
                                            className="product-card-list"
                                            key={i}
                                            item
                                            xs={11}>
                                            <ProductCard
                                                productInfo={item}
                                                customerData={
                                                    this.props.localData
                                                }
                                                history={this.props.history}
                                                itemPosition={'homepage'}
                                                addShoppingCart={
                                                    this.addShoppingCart
                                                }
                                                isProduct={true}
                                                isDemoSite={isDemoSite}
                                                quoteInfor={quoteCustomerInfor}
                                                isQuoteInfor={isQuoteInfor}
                                                closeQuoteDetails={
                                                    this.closeQuoteDetails
                                                }
                                                copyContent={this.copyContent}
                                                operation={this.viewSkuDetail}
                                                currentProductType={
                                                    currentProductType
                                                }
                                                isProxyProcessType={
                                                    isProxyProcessType
                                                }
                                                addPageType={addPageType}
                                                otherDivision={true}
                                            />
                                        </Grid>
                                    );
                                })}
                        </Grid>
                    )}

                    {!pageLoad &&
                    displayTMProduct &&
                    chooseProductList.data &&
                    chooseProductList.data.length === 0 ? (
                        <Grid
                            className="contact-us-info"
                            container
                            spacing={0}
                            justify={'space-evenly'}>
                            <Grid
                                className="contact-us-title"
                                id="noTfsProductFound"
                                item
                                xs={12}>
                                <span>{T('order_search_tf_no_result')}</span>
                            </Grid>
                            <Grid
                                className="contact-us-row contact_us"
                                item
                                xs={10}>
                                <span>{T('need_help_contact_us')}</span>
                            </Grid>

                            {/* <Grid className='contact-us-row' item xs={10}>
                                                    <span><Link href={'tel://400 820 8982'}>{T('contact_telephone_one')}</Link> / <Link href={'tel://800 820 8982'}>{T('contact_telephone_two')}</Link></span>
												</Grid> */}

                            <Grid
                                className="contact-us-row contact-business-row"
                                item
                                xs={12}>
                                <span className="contact-us-label">
                                    {T('order_service_hot_line')}
                                </span>
                                {/* <Link href={'tel://8008208982'}>{T('order_service_hot_line_number')}</Link> */}
                                <span className="contact-us-telephone">
                                    <Link c href={'tel://400 820 8982'}>
                                        {T('contact_telephone_one')}
                                    </Link>{' '}
                                    /{' '}
                                    <Link href={'tel://800 820 8982'}>
                                        {T('contact_telephone_two')}
                                    </Link>
                                </span>
                            </Grid>

                            <Grid
                                className="contact-us-row contact-business-row"
                                item
                                xs={12}>
                                <span className="contact-us-label">
                                    {T('order_business_consult')}
                                </span>
                                <span className="contact-us-email">
                                    {T('order_business_consult_email')}
                                </span>
                            </Grid>
                        </Grid>
                    ) : null}

                    {productList.pageNum >= productList.pageTotal &&
                    !displayTMProduct &&
                    !isDemoSite &&
                    searchValue ? (
                        <Grid
                            className={
                                chooseProductList.data.length === 0
                                    ? 'thermofisher-product-button top-margin'
                                    : 'thermofisher-product-button'
                            }
                            item
                            xs={12}>
                            <Grid
                                id="noProductFound"
                                className={
                                    chooseProductList.data.length === 0
                                        ? 'no-product-message'
                                        : 'find-product-message'
                                }>
                                {T('pleaseContinueIfNotFound')}
                            </Grid>
                            <BasicButton
                                disabled={false}
                                onClickOfSingleTap={() =>
                                    this.displayTMProduct(null)
                                }
                                testid="click-me-to-continue-searching-btn"
                                type="primary">
                                <div className="search-icon-bottom">
                                    <TouchAppSharp />
                                </div>
                                {T('clickMeToContinueSearching')}
                            </BasicButton>
                        </Grid>
                    ) : null}
                </ScrollWrapper>

                <Dialog
                    contentStyle={{width: '100%'}}
                    dialogDidClose={() =>
                        this.closeDialog('onlineOrderDialogOpened')
                    }
                    opened={onlineOrderDialogOpened}
                    isBottomDialog={true}
                    options={{bgClickClose: false}}>
                    <div className="please-advised-dialog">
                        <Grid className="dialog-title" container spacing={0}>
                            <Grid item xs={12}>
                                <span>
                                    {T('lto_purchase_order_please_advised')}
                                </span>
                            </Grid>
                        </Grid>

                        <Grid
                            className="dialog-content"
                            container
                            spacing={0}
                            justify={'center'}>
                            <Grid item xs={10}>
                                {util.getPurchaseOrderMode() ===
                                PURCHASE_ORDER_MODE.ONLINE ? (
                                    <ul>
                                        <li>
                                            {T(
                                                'lto_purchase_order_please_advised_content1',
                                            )}
                                        </li>
                                        <li>
                                            {T(
                                                'lto_purchase_order_please_advised_content21',
                                            )}
                                            <strong>
                                                {T(
                                                    'lto_purchase_order_please_advised_content22',
                                                )}
                                            </strong>
                                            {T(
                                                'lto_purchase_order_please_advised_content23',
                                            )}
                                            <strong>
                                                {T(
                                                    'lto_purchase_order_please_advised_content24',
                                                )}
                                            </strong>
                                            {T(
                                                'lto_purchase_order_please_advised_content25',
                                            )}
                                        </li>
                                    </ul>
                                ) : (
                                    <div className="offline-reminder-container">
                                        <div className="offline-reminder-message1">
                                            {T('new_offline_reminder_message1')}
                                            <span className="offline-reminder-highlight">
                                                {T(
                                                    'new_offline_reminder_message1_part2',
                                                )}
                                            </span>
                                        </div>
                                        <div className="offline-reminder-message2">
                                            {T('new_offline_reminder_message2')}
                                        </div>
                                        <div className="offline-reminder-message3">
                                            {T('new_offline_reminder_message3')}
                                        </div>
                                    </div>
                                )}
                                {util.getPurchaseOrderMode() ===
                                PURCHASE_ORDER_MODE.ONLINE ? (
                                    <span className="online-reminder-last-message">
                                        {T(
                                            'lto_purchase_order_please_advised_content3',
                                        )}
                                    </span>
                                ) : null}
                            </Grid>
                        </Grid>

                        <Grid container spacing={0}>
                            <Grid item xs={12} align="center">
                                <BasicButton
                                    className="close-confirm-btn"
                                    type="primary"
                                    testid="close-advised-order-dialog-btn"
                                    disabled={false}
                                    onClickOfSingleTap={() =>
                                        this.closeDialog(
                                            'onlineOrderDialogOpened',
                                        )
                                    }>
                                    <div>
                                        {T('lto_purchase_order_close_tip_info')}
                                        {/* <label className="close-timer">
                                            {T('lto_purchase_order_timer', [
                                                timer,
                                            ])}
                                        </label> */}
                                    </div>
                                </BasicButton>
                            </Grid>
                        </Grid>
                    </div>
                </Dialog>

                <Dialog
                    contentStyle={{width: '100%'}}
                    dialogDidClose={this.closeWarning}
                    opened={warningOpen}
                    options={{bgClickClose: true}}>
                    <div className="warning-popup">
                        <Grid
                            className="warning-title-container"
                            container
                            spacing={0}>
                            <Grid className="warning-title-grid" item xs={12}>
                                <p className="user-not-activate">
                                    {T('welcome_demosite')}
                                </p>
                                <p>
                                    {T('return_tfs_website')}
                                    <a href="https://www.thermofisher.cn/mobility-sp">
                                        {T('thermofisher_link')}
                                    </a>
                                    {T('please_click_link')}
                                    <a href="https://www.thermofisher.cn/mobility-sp">
                                        {T('mapac_thermofisher_email')}
                                    </a>
                                    {T(
                                        'enjoy_ultimate_experience_one_stop_service',
                                    )}
                                </p>
                                <p className="supply-center-china-email-container">
                                    {T('anyway_problem_please_call')}
                                    <a
                                        href="mailto:supplycenterchina@thermofisher.com"
                                        target="_blank">
                                        {T('supplycenterchina_email')}
                                    </a>
                                    {'。'}
                                    {/* <Email /> */}
                                </p>
                            </Grid>
                        </Grid>
                    </div>
                </Dialog>

                <Dialog
                    dialogDidClose={() => this.closeDialog('exitOpened')}
                    opened={exitOpened}
                    options={{bgClickClose: true}}>
                    <div className="logout-dialog">
                        <Grid className="dialog-title" container spacing={0}>
                            <Grid item xs={12}>
                                <span>{T('user_center_logout')}</span>
                            </Grid>
                        </Grid>

                        <Grid
                            className="dialog-content"
                            container
                            spacing={0}
                            justify={'center'}>
                            <Grid item xs={12}>
                                <span>{T('user_center_logout_message')}</span>
                            </Grid>
                        </Grid>

                        <Grid container spacing={0}>
                            <Grid item xs={12} align="center">
                                <BasicButton
                                    className="confirm-btn"
                                    type="primary"
                                    disabled={false}
                                    onClickOfSingleTap={this.exitCustomer}>
                                    <span>{T('user_center_logout')}</span>
                                </BasicButton>
                            </Grid>
                        </Grid>
                    </div>
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {order, localData} = state;
    return {
        shipTo: order.shipTo,
        defaultShipToAndSc: order.defaultShipToAndSc,
        categoryList: order.categoryList,
        categroySelected: order.categroySelected,
        searchProductList: order.searchProductList,
        productList: order.productList,
        listLoaded: order.productListLoaded,
        productLoadingMore: order.productLoadingMore,
        localData: localData,
        cartCount: order.cartCount,
        tmProductList: order.tmProductList,
        otherShipToNumber: order.otherShipToNumber,
        quoteInfor: order.quoteInfor.data,
        quoteCustomerInfor: order.quoteCustomerInfor.data,
        searchValue: order.searchValue,
        fromProductSearchPage: order.fromProductSearchPage,
        fromShoppingCart: order.fromShoppingCart,
    };
};

const mapDispatchToProps = {
    getShipToInfo,
    getCategoryList,
    updateCategroySelected,
    getProductList,
    getMoreProducts,
    addCart,
    getCartCount,
    getDefaultShipToAndSC,
    queryTMSKUList,
    setUserData,
    mockLogin,
    unBindGigya,
    openNotification,
    updateOtherShipToNumber,
    updateProductSearchFields,
    getQuote,
    getCustomerQuote,
    operationLog,
    updateProducts,
    queryEoneInventory,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductList);
